import type { ReactNode } from "react";

/** Makes a pill on a detail page clickable: it runs `onClick`, which sets the page's search.
 * A plain click replaces the search; a ⌘-click (Ctrl-click off a Mac) passes `toggle`, which
 * adds the pill's term to the search or, if it's already there, takes it out. Titled with
 * what it will search for. Without `onClick` it's the plain pill. */
export function PillButton({
  onClick,
  title,
  children,
}: {
  onClick?: (toggle: boolean) => void;
  title: string;
  children: ReactNode;
}) {
  if (!onClick) return <>{children}</>;
  return (
    <button
      type="button"
      onClick={(e) => onClick(e.metaKey || e.ctrlKey)}
      title={`${title} (⌘-click to add to or remove from the search)`}
      className="cursor-pointer rounded-full hover:opacity-80"
    >
      {children}
    </button>
  );
}
